// ADDRESS SEARCH index
import mutations from './mutations';
import actions from './actions';
import getters from './getters';

export default {
  state: {
    predictions: {
      google: [],
      api: [],
    },
  },
  actions,
  mutations,
  getters,
};
